import {
  BarChart,
  BookOpen,
  CalendarRange,
  CircleDollarSign,
  CircleUser,
  Dumbbell,
  FileBarChart,
  HandCoins,
  Menu,
  NotebookTabs,
  NotepadText,
  ReceiptText,
  TextSelect,
  User,
  UserPlus,
  Users,
  Warehouse
} from 'lucide-react'

import { Button } from '@/view/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/view/components/ui/dropdown-menu'
import { Sheet, SheetContent, SheetTrigger } from '@/view/components/ui/sheet'

import { Toaster } from 'react-hot-toast'

import { startTransition, useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { RoutesPath } from '../../../configs/routes-path'
import { useLocalStorage } from '../../../remote/local-storage'
import logo from '../../assets/acelera-logo.png'
import { SelectUnit } from '../../components/select-unit'
import { useNavigateRoute } from '../../hooks/navigation'
import { useCashfitParams } from '../../hooks/use-params'

export default function DashboardNavigation() {
  const [params] = useSearchParams()
  const { navigateTo } = useNavigateRoute()
  const { getUnitId } = useLocalStorage()

  const { setParams } = useCashfitParams({
    unit: getUnitId(),
    navId: params.get('navId') || '1'
  })

  const [sidebar, setSidebar] = useState(defaultSidebar)

  const { isProfileAdmin, isProfileAdministrator, isProfileAttendantCash, clearStorage, isProfilePersonal } = useLocalStorage()

  const setClicked = (id: number, path: RoutesPath) => {
    const sidebarSelect = sidebar.find((item) => item.selected)
    if (sidebarSelect?.id == id) return
    const sideBarUpdated = sidebar.map((item: any) => {
      item.selected = false
      if (item.id == id) item.selected = true
      return item
    })
    setSidebar(sideBarUpdated)
    setParams({
      navId: id.toString(),
      unit: getUnitId()
    } as any)
    sidebarSelected(id)
    navigateTo(`${path}?unit=${getUnitId()}&navId=${id}` as RoutesPath)
  }

  const logout = () => {
    startTransition(() => {
      clearStorage()
      navigateTo(RoutesPath.login)
    })
  }

  const sidebarSelected = (id: number) => {
    const sideBarUpdated = sidebar
      .map((item: any) => {
        item.selected = false
        item.show = true

        if ([RoutesPath.dashboard].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.reception].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator() || isProfileAttendantCash()

        if ([RoutesPath.students].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator() || isProfileAttendantCash()

        if ([RoutesPath.consultant].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.finance].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.reports].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.gyns].includes(item.path)) item.show = isProfileAdmin()

        if ([RoutesPath.plans].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.employees].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.sales].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator() || isProfileAttendantCash()

        if ([RoutesPath.costCenter].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.units].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.users].includes(item.path)) item.show = isProfileAdmin()

        if ([RoutesPath.roomsAndSessions].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator() || isProfilePersonal()

        if ([RoutesPath.contract].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if ([RoutesPath.cashRegister].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator() || isProfileAttendantCash()

        if ([RoutesPath.servicesAndProducts].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator() || isProfileAttendantCash()

        if ([RoutesPath.excercise].includes(item.path)) item.show = isProfileAdmin() || isProfileAdministrator()

        if (item.id == parseInt(id?.toString() || '1')) item.selected = true
        return item
      })
      .filter((item) => item.show)

    setSidebar(sideBarUpdated)
  }

  useEffect(() => {
    if (params.get('navId')) sidebarSelected(Number(params.get('navId')))
  }, [params])

  return (
    <div className="grid min-h-screen w-full md:grid-cols-[220px_1fr] lg:grid-cols-[280px_1fr]">
      <Toaster position="top-right" reverseOrder={false} toastOptions={{}} />
      <div className="hidden border-r bg-muted/40 md:block">
        <div className="flex h-full max-h-screen flex-col gap-2">
          <div className="flex h-14 items-center border-b px-4 lg:h-[60px] lg:px-6">
            <img src={logo} alt="acelera-logo" className="mr-2 h-8 w-8" />
            <a className="flex items-center gap-4 font-semibold">
              <span className="italic font-black text-3xl">GESTÃO</span>
            </a>
            {/* <Button variant="outline" size="icon" className="ml-auto h-8 w-8">
              <Bell className="h-4 w-4" />
              <span className="sr-only">Toggle notifications</span>
            </Button> */}
          </div>
          <div className="flex-1">
            <nav className="grid items-start px-2 text-sm font-medium lg:px-4">
              {sidebar.map(({ Icon, label, path, selected, id }) => (
                <a
                  key={id}
                  className={`flex items-center gap-3 rounded-lg px-3 py-2 transition-all cursor-pointer ${selected ? 'bg-acelerafit-green-400 text-muted' : 'text-muted-foreground'}`}
                  onClick={() => setClicked(id, path)}
                >
                  <Icon />
                  {label}
                </a>
              ))}
            </nav>
          </div>
          <div className="mt-auto p-4"></div>
        </div>
      </div>
      <div className="flex flex-col">
        <header className="flex h-14 items-center gap-4 border-b bg-muted/40 px-4 lg:h-[60px] lg:px-6">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="outline" size="icon" className="shrink-0 md:hidden">
                <Menu className="h-5 w-5" />
                <span className="sr-only">Toggle navigation menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="left" className="flex flex-col">
              <nav className="grid gap-2 text-lg font-medium">
                <a className="flex items-center gap-2 text-lg font-semibold">
                  <span className="italic font-black text-xl">GESTÃO</span>
                </a>
                {sidebar.map(({ Icon, label, path, selected, id }) => (
                  <a
                    key={id}
                    className={`mx-[-0.65rem] flex items-center gap-4 rounded-xl px-3 py-2 text-muted-foreground cursor-pointer ${
                      selected ? 'bg-acelerafit-green-400 text-muted hover:text-muted' : ''
                    } `}
                    onClick={() => setClicked(id, path)}
                  >
                    <Icon />
                    {label}
                  </a>
                ))}
              </nav>
              <div className="mt-auto"></div>
            </SheetContent>
          </Sheet>
          <div className="w-full flex-1">
            <div className="max-w-96 flex gap-2 items-center">
              <label className="text-xs">Unidade</label>
              <SelectUnit />
            </div>
          </div>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="secondary" size="icon" className="rounded-full">
                <CircleUser className="h-5 w-5" />
                <span className="sr-only"></span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>Conta</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout}>Sair</DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </header>
        <main className="flex flex-1 flex-col gap-4 p-4 lg:gap-6 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  )
}

const defaultSidebar = [
  {
    id: 1,
    Icon: BarChart,
    label: 'Dashboards',
    path: RoutesPath.dashboard,
    selected: true
  },
  {
    id: 2,
    Icon: BookOpen,
    label: 'Recepção',
    path: RoutesPath.reception,
    selected: false
  },
  {
    id: 16,
    Icon: CircleDollarSign,
    label: 'Caixa',
    path: RoutesPath.cashRegister,
    selected: false
  },

  {
    id: 3,
    Icon: Users,
    label: 'Alunos',
    path: RoutesPath.students,
    selected: false
  },
  {
    id: 15,
    Icon: CalendarRange,
    label: 'Aulas',
    path: RoutesPath.roomsAndSessions,
    selected: false
  },
  {
    id: 4,
    Icon: HandCoins,
    label: 'Centro de Custo',
    path: RoutesPath.costCenter,
    selected: false
  },
  {
    id: 12,
    Icon: Warehouse,
    label: 'Unidades',
    path: RoutesPath.units,
    selected: false
  },
  {
    id: 9,
    Icon: TextSelect,
    label: 'Planos',
    path: RoutesPath.plans,
    selected: false
  },

  // {
  //   id: 5,
  //   Icon: Handshake,
  //   label: 'Consultor APP',
  //   path: RoutesPath.consultant,
  //   select: false
  // },
  // {
  //   id: 6,
  //   Icon: DollarSign,
  //   label: 'Financeiro',
  //   path: RoutesPath.finance,
  //   selected: false
  // },

  // {
  //   id: 8,
  //   Icon: Dumbbell,
  //   label: 'Minha academia',
  //   path: RoutesPath.gyns,
  //   selected: false
  // },

  // {
  //   id: 11,
  //   Icon: CreditCard,
  //   label: 'Vendas',
  //   path: RoutesPath.sales,
  //   selected: false
  // },

  {
    id: 13,
    Icon: UserPlus,
    label: 'Usuários',
    path: RoutesPath.users,
    selected: false
  },

  {
    id: 14,
    Icon: ReceiptText,
    label: 'Contratos',
    path: RoutesPath.contract,
    selected: false
  },
  {
    id: 17,
    Icon: Dumbbell,
    label: 'Exercícios',
    path: RoutesPath.excercise,
    selected: false
  },
  {
    id: 19,
    Icon: NotebookTabs,
    label: 'Ficha de Exercícios',
    path: RoutesPath.sheetExercise,
    selected: false
  },
  {
    id: 18,
    Icon: NotepadText,
    label: 'Serviços e Produtos',
    selected: false,
    path: RoutesPath.servicesAndProducts
  },
  {
    id: 7,
    Icon: User,
    label: 'Funcionários',
    path: RoutesPath.employees,
    selected: false
  },
  {
    id: 10,
    Icon: FileBarChart,
    label: 'Relatórios',
    path: RoutesPath.reports,
    selected: false
  }
]
